<template>
    <div class="document-debug">
        <div>
            <link-button label="重置" icon="icon-trash" @click="reset"/>&nbsp;
            <link-button label="复制当前代码" icon="icon-purchase-order" @click="copy"/>&nbsp;
            <link-button label="运行" icon="icon-refresh" @click="run"/>&nbsp;
        </div>
        <div class="debug-editor">
            <div class="debug-editor-textarea">
                <link-codemirror v-model="p_text" @keydown.ctrl.83.prevent="run" mode="html"/>
            </div>
            <div class="debug-editor-example">
                <link-document-item-demo-instance v-bind="instance" v-if="!!instance"/>
            </div>
        </div>
    </div>
</template>

<script>
    import LinkDocumentItemDemoInstance from "../document/link-document-item-demo-instance";

    export default {
        name: "debug",
        components: {LinkDocumentItemDemoInstance},
        data() {
            let {html, css, js} = this.pageParam
            html = this.pl_wrapper('template', html || '')
            js = this.pl_wrapper('script', js || '')
            css = this.pl_wrapper('style', css || '')
            const text = `${html}\n\n${js}\n\n${css}`
            return {
                text: text,
                p_text: text,
                instance: null,
            }
        },
        created() {
            this.run()
        },
        methods: {
            pl_wrapper(tag, val) {
                return `<${tag}>\n` + val + `\n</${tag}>`
            },
            reset() {
                this.p_text = this.text
                this.run()
            },
            copy() {
                this.$lv.$utils.copyToClipboard(this.p_text, () => this.$msg.show("复制成功！"), () => this.$msg.show("复制失败！", {type: 'error'}))
            },
            run() {
                this.instance = null
                let text = this.p_text
                const data = {
                    html: 'template',
                    css: 'style',
                    js: 'script',
                }
                Object.keys(data).forEach(type => {
                    const startTag = `<${data[type]}>`
                    const endTag = `</${data[type]}>`
                    let startIndex = text.indexOf(startTag) + startTag.length
                    let endIndex = text.lastIndexOf(endTag)

                    let content = text.substring(startIndex, endIndex)
                    text = text.replace(content, '')
                    data[type] = content || ''
                })
                this.instance = data
            },
        },
    }
</script>

<style lang="scss">
    @include themeify {
        .document-debug {
            display: flex;
            flex-direction: column;

            .debug-editor {
                flex: 1;
                border: solid 1px pl-var(color-normal-border);
                border-radius: 4px;
                box-sizing: border-box;
                display: flex;
                margin-top: 16px;
            }

            .debug-editor-textarea, .debug-editor-example {
                width: 500px;
                height: 100%;
                flex: 1;
                padding: 16px;
                box-sizing: border-box;
            }

            .debug-editor-example {
                border-left: solid 1px pl-var(color-normal-border);
                overflow-y: auto;
            }

            .debug-editor-textarea {
                textarea {
                    height: 100%;
                    width: 100%;
                    font-size: 16px;
                    border: none;
                    outline: none;
                    line-height: 28px;
                    font-family: Consolas, Courier New, serif;
                    color: pl-var(color-normal-content);
                }
            }


        }
    }
</style>
